module.exports = __webpack_public_path__ + "static/media/home-scale.5f865aa2.jpg";